import React from 'react';
import axios from "axios";
import { BUBBLE_LOADING } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_APPEND } from '../../constants/DotEnv';
import HilfeCenterPageHeader from '../subPageHeader/SubPageHeader';
class HilfeCenter extends React.Component {
    constructor() {
        super();
        this.state = {
            hilfecenterdata: {},
            loading: 'false',
            dataLength: '',
            title: ''
        }
    }
    componentDidMount() {
        this.scrollUpFunction();
        this.hilfeCenterContent();
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        let count = document.querySelector('.navbar-toggler').className.indexOf("collapsed");
        if (count === -1) {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('header').classList.remove("header_collapse");
            document.querySelector('.navbar-toggler').setAttribute("aria-expanded", false);
        }
    }
    hilfeCenterContent = () => {
        this.setState({ loading: 'true' })
        let self = this;
        let hilfecenterdata = '';
        let dataLength = '';
        let title = '';
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        axios.get(API_URL + '/cms/getCmsByID/92/' + LANGUAGE_CODE)
            .then((response) => {
                hilfecenterdata = response.data.success.cms;
                dataLength = Object.keys(hilfecenterdata).length;
                title = hilfecenterdata['title'];
                meta_title = hilfecenterdata['title'] + META_TITLE_APPEND
                meta_description = hilfecenterdata['metadescription']
                meta_keywords = hilfecenterdata['metakeyword']
                window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                window.setDocumentTitle(meta_title)
                self.setState({ loading: 'false', hilfecenterdata, dataLength, title })
            })
            .catch((error) => {
                self.setState({ loading: 'false' })
            })
    }
    render() {
        let length = Object.keys(this.state.hilfecenterdata).length
        let hilfecenterdata = this.state.hilfecenterdata;
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                <HilfeCenterPageHeader data={hilfecenterdata} title={this.state.title} dataLength={this.state.dataLength} />
                {(length > 0 && this.state.loading === 'false') ?
                    <section className="section-blog">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="blog-lising">
                                        <div dangerouslySetInnerHTML={{ __html: hilfecenterdata['content'] }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
                }
            </main>
        );
    }
}
export default HilfeCenter;